"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAPIContext = void 0;
const react_1 = __importDefault(require("react"));
const EventAPIContext = react_1.default.createContext({});
const useAPIContext = () => react_1.default.useContext(EventAPIContext);
exports.useAPIContext = useAPIContext;
exports.default = EventAPIContext;
